<div class="attachment-strip" [class.card-footer]="variant === 'cardFooter'" *ngIf="chips.length > 0 || errorMessage">
  <div class="attachment-header">
    <i class="fa-solid fa-paperclip"></i>
    <span *ngIf="!errorMessage">{{ label || ((chips.length === 1 ? 'Attachment' : 'Attachments') + ' (' + chips.length + ')') }}</span>
    <span *ngIf="errorMessage" class="attachment-error">{{ errorMessage }}</span>
  </div>
  <div class="attachment-chips" *ngIf="!errorMessage">
    <button
      *ngFor="let chip of chips; let i = index"
      type="button"
      class="attachment-chip"
      [title]="chip.Filename + ' — ' + formatSize(chip.SizeBytes)"
      (click)="handleChipClick(chip, i)">
      <i class="attachment-chip-icon" [ngClass]="[iconClass(chip.MimeType), iconColorClass(chip.MimeType)]"></i>
      <span class="attachment-chip-name">{{ chip.Filename }}</span>
      <span class="attachment-chip-size">{{ formatSize(chip.SizeBytes) }}</span>
    </button>
  </div>
</div>
